import { forwardRef, type Ref, type SVGProps } from "react";
const IconFileSplitFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M27 27.999a2.006 2.006 0 0 1-2 2H7a2.006 2.006 0 0 1-2-2V22h22z"
    />
    <path
      fill="currentColor"
      d="M7 19c.552.002.998.448 1 1a1.003 1.003 0 0 1-1 1H4a1 1 0 1 1 0-2z"
    />
    <path
      fill="currentColor"
      d="M14 19c.552.002.998.448 1 1a1.003 1.003 0 0 1-1 1h-3a1 1 0 1 1 0-2z"
    />
    <path
      fill="currentColor"
      d="M21 19c.552.002.998.448 1 1a1.003 1.003 0 0 1-1 1h-3a1 1 0 1 1 0-2z"
    />
    <path
      fill="currentColor"
      d="M28 19c.552.002.998.448 1 1a1.003 1.003 0 0 1-1 1h-3a1 1 0 1 1 0-2z"
    />
    <path
      fill="currentColor"
      d="M7 15c.552.002.998.448 1 1a1.003 1.003 0 0 1-1 1H4a1 1 0 1 1 0-2z"
    />
    <path
      fill="currentColor"
      d="M14 15c.552.002.998.448 1 1a1.003 1.003 0 0 1-1 1h-3a1 1 0 1 1 0-2z"
    />
    <path
      fill="currentColor"
      d="M21 15c.552.002.998.448 1 1a1.003 1.003 0 0 1-1 1h-3a1 1 0 1 1 0-2z"
    />
    <path
      fill="currentColor"
      d="M28 15c.552.002.998.448 1 1a1.003 1.003 0 0 1-1 1h-3a1 1 0 1 1 0-2z"
    />
    <path
      fill="currentColor"
      d="M18 10c.002.552.448.998 1 1h8v3H5V4a2.006 2.006 0 0 1 2-2h11z"
    />
    <path
      fill="currentColor"
      d="M20 2c.473.138.907.386 1.264.726l.268.26 4.483 4.482.26.268c.339.358.588.79.725 1.264h-7z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconFileSplitFilledSVG);
ForwardRef.displayName = "IconFileSplitFilled";
export { ForwardRef as IconFileSplitFilled };
